// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 6207) return "static/chunks/89adb2d6-b5b9bc50e081e816.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 1922 ? "39fc8a16" : chunkId) + "." + {"685":"5e6432931dab997d","1922":"147008d83c843fb8","3160":"be6a43c2bddf6b58","3380":"9edb82f79a26c95b","4133":"7d0b6355fdc11d35","5859":"a6659bbe528c2379","6607":"5e0501c867857295","8240":"ac31010a49e650cc","8716":"b6f4d9c217dbb7dd"}[chunkId] + ".js";
};